// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"24e25a34","703":"fe6e5e37"}[chunkId] + ".chunk.js";
};